import {
    fetchStockById,
    updateStock,
    deleteStockById
} from "../../../services/Edit/stockService";
import { refreshUserTransactions } from "../../../utils/refreshUser";
// 🔹 FETCH SINGLE TRANSACTION
export const handleFetchStock = async ({
    partnerId,
    transactionId,
    setForm,
    setIsEditing,
    showToast
}) => {
    try {
        const data = await fetchStockById(partnerId, transactionId);

        setForm(data);
        setIsEditing(true);

        showToast("Fetched successfully");
    } catch (err) {
        console.log(err);
        showToast(err.message || "Fetch failed", "error");
    }
};

// 🔹 UPDATE TRANSACTION
export const handleUpdateStock = async ({
    e,
    form,
    resetForm,
    showToast,
    navigate,
    setIsUpdating,
    userId
}) => {
    e.preventDefault();

    try {
        setIsUpdating(true);
        if (!form?.partnerId || !form?.id) {
            throw new Error("Missing partnerId or transactionId");
        }

        await updateStock(
            form.partnerId,
            form.id,
            {
                ...form,
                rate: Number(form.rate),
                quantity: Number(form.quantity),
                amount: Number(form.amount)
            }
        );
        // ✅ CLEAR CACHE
        await refreshUserTransactions(userId);
        showToast("Updated successfully");
        resetForm();
        navigate("/");
    } catch (error) {
        showToast(error.message || "Update failed", "error");
    } finally {
        setIsUpdating(false);
    }
};

// 🔹 DELETE TRANSACTION
export const handleDeleteStock = async ({
    form,
    resetForm,
    showToast,
    userId
}) => {
    try {
        if (!form?.partnerId || !form?.id) {
            throw new Error("Missing partnerId or transactionId");
        }

        await deleteStockById(
            form.partnerId,
            form.id
        );

        // ✅ CLEAR CACHE
        await refreshUserTransactions(userId);
        showToast("Deleted successfully");
        resetForm();
    } catch (error) {
        console.log(error);
        showToast(error.message || "Delete failed", "error");
    }
};